import * as yup from "yup";

export const accountDeletionStep3Schema = yup.object({
    password: yup
    .string()
    .required("Обязательное поле")
});

export type UpdateUserFormValues = yup.InferType<typeof accountDeletionStep3Schema>;